/**
 * Credibility Section Configuration
 * All copy stored in a single config for easy iteration without touching layout logic.
 */

// Hero Proof Chips - Tier-1 Safe Proof Anchors
export const heroProofChips = [
  '1–660 kW class thermal systems',
  'Multi-service deployments + export deliveries',
  'Configuration-controlled builds',
  'FAT/ATP evidence-pack readiness',
  'Multi-kiloamp power distribution & control',
  '300 bar-class regulated pressurization systems'
];

// Confidentiality Note
export const confidentialityNote = {
  text: 'Confidential by default.',
  subtext: 'Program names, reference letters, and product visuals are shared only with verified stakeholders through a secure technical discussion.',
  ctaText: 'Request Technical Briefing'
};
